var getRisk = function (risk, risks) {
    return risks.find(function (r) { return risk >= r.zrisk; });
};

export { getRisk };
